import { useRef } from 'react';
import { VideoRefs } from '../types/socialGlass';

export const useVideoControls = () => {
  const videoRefs = useRef<VideoRefs>({});

  const handleManualMute = () => {
    Object.values(videoRefs.current).forEach((v) => {
      if (v) v.muted = true;
    });
  };

  const handleManualUnmute = () => {
    Object.values(videoRefs.current).forEach((v) => {
      if (v) v.muted = false;
    });
  };

  return {
    videoRefs,
    handleManualMute,
    handleManualUnmute,
  };
};
